module.exports = __webpack_public_path__ + "img/richgo_mobile_logo.d88dc877.png";